import styled from '@emotion/styled';

export const StyledDesktopRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
  minHeight: 32,
}));

export const StyledTitleGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[12],
  minWidth: 0,
}));

export const StyledActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  flexShrink: 0,
}));

export const StyledMobileRoot = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  columnGap: theme.spacing[8],
  minHeight: 32,
}));

export const StyledMobileStart = styled('div')({
  display: 'flex',
  justifySelf: 'start',
});

export const StyledMobileCenter = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  minWidth: 0,
});

export const StyledSubtitleZone = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing[8],
}));

export const StyledMobileActions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifySelf: 'end',
  gap: theme.spacing[4],
}));
